import React, { useState } from 'react';
import classnames from 'classnames';
import { actions } from '@ignitesales/neuro-application';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import GuideAssistant, { ACTIONS } from "../../refactor/guideAssistant/GuideAssistant";
import MerlinIcon from "../merlin/MerlinIcon.jsx";
import getLandingPageSteps from "../../utils/guideAssistantSteps/getLandingPageSteps";

const { startGuide } = actions.navigation;

const LandingPage = ({className, startGuideClicked, processingNavigation}) => {
  const cssBEM = 'landingPage';
  const classes = classnames(cssBEM, className);

  const [ assistantState, setAssistantState ] = useState({
    hasStarted: false,
    stepIndex: 0
  });

  const onGuideAssistantChange = data => {
    const { action } = data;
    if(action === ACTIONS.CLOSE || action === ACTIONS.STOP) {
      setAssistantState({
        ...assistantState,
        run: false
      })
    }else if(action === ACTIONS.START) {
      setAssistantState({
        ...assistantState,
        hasStarted: true
      })
    }
  };

  const onMerlinClick = () => {
    if(!assistantState.hasStarted){
      setAssistantState({
        ...assistantState,
        hasStarted: true,
        run: true,
        stepIndex: 0
      })
    }
  };

  const onStartGuideClick = () => {
    setAssistantState({
      ...assistantState,
      run: false
    });
    startGuideClicked('checking');
  };

  return (
    <div className={classes}>
      <div className="container">
        <div className={`${cssBEM}__leftSide`}>
          <FormattedMessage id="landing.subtitle" tagName="h5" />
          <FormattedMessage id="landing.title" tagName="h2" />
          <FormattedMessage id="landing.message" tagName="span" />
          <button onClick={onStartGuideClick} disabled={processingNavigation} className="btn btn-primary">
            <FormattedMessage id="landing.readyToStart" />
          </button>
        </div>
        <div className={`${cssBEM}__rightSide`}>
          <div className="petals">
            <div className="petal"/>
            <div className="petal"/>
            <div className="petal"/>
            <MerlinIcon id="landing-page-merlin" pulseForever={true} onClick={onMerlinClick} />
          </div>
        </div>
      </div>
      <GuideAssistant
        id="landing"
        steps={ getLandingPageSteps(onStartGuideClick) }
        onChange={ onGuideAssistantChange }
        hideBackButton={true}
        delay={10000}
        floaterProps={{
          disableAnimation: true
        }}
        { ...assistantState }
      />
    </div>
  );
};

export default connect(
  ({ processingNavigation = false }) => {
    return {
      processingNavigation,
    };
  },
  (dispatch) => {
    return {
      startGuideClicked: (selectedPath) => dispatch(startGuide(selectedPath)),
    };
  }
)(LandingPage);
